import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { AlertCircle, X } from 'lucide-react';

function PlatformConsentModal({ platformName, onConfirm, onCancel }) {
  const [accepted, setAccepted] = useState(false);
  const { t } = useTranslation();

  const handleConfirm = () => {
    if (!accepted) {
      return;
    }
    onConfirm();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-lg w-full p-6 animate-slide-up">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center space-x-2">
            <AlertCircle className="text-sky-600" size={24} />
            <h2 className="text-xl font-bold text-gray-800">{t('app.platformConsent.title')}</h2>
          </div>
          <button
            onClick={onCancel}
            className="text-gray-400 hover:text-gray-600 transition"
            aria-label={t('app.platformConsent.close')}
          >
            <X size={24} />
          </button>
        </div>

        <div className="mb-6">
          <p className="text-gray-700 mb-4">
            <Trans i18nKey="app.platformConsent.description" values={{ platformName }} components={{ strong: <strong /> }} />
          </p>
          
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-4">
            <p className="text-sm text-blue-800">
              <strong>{t('app.platformConsent.meaningTitle')}</strong>
              <br />
              {t('app.platformConsent.meaningDescription')}
            </p>
          </div>

          <div className="flex items-start space-x-3 p-4 border-2 border-gray-300 rounded-lg hover:border-sky-300 transition">
            <input
              type="checkbox"
              id="platformConsent"
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
              className="mt-1 h-5 w-5 text-sky-500 border-gray-300 rounded focus:ring-sky-500"
            />
            <div className="flex-1">
              <label htmlFor="platformConsent" className="text-sm text-gray-700 cursor-pointer">
                <Trans i18nKey="app.platformConsent.checkbox" values={{ platformName }} components={{ strong: <strong /> }} />
              </label>
              <p className="text-xs text-gray-500 mt-2">
                <Trans
                  i18nKey="app.platformConsent.moreInfo"
                  components={{
                    link: <Link to="/platform-access" className="text-sky-600 hover:text-sky-700 underline" target="_blank" />
                  }}
                />
              </p>
            </div>
          </div>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 py-3 px-4 border-2 border-gray-300 text-gray-700 font-semibold rounded-lg hover:bg-gray-50 transition"
          >
            {t('app.platformConsent.cancel')}
          </button>
          <button
            onClick={handleConfirm}
            disabled={!accepted}
            className="flex-1 py-3 px-4 bg-gradient-to-r from-sky-500 to-emerald-500 text-white font-semibold rounded-lg hover:from-sky-600 hover:to-emerald-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {t('app.platformConsent.continue')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default PlatformConsentModal;
